/**
 * getFunctionName
 * @description 関数の名前を取得
 * @param {Function} func 関数
 * @returns {string}
 */
export default function getFunctionName(func: Function): string {
  if (func.name) {
    return func.name;
  } else if (func.constructor.name) {
    return func.constructor.name;
  }

  const name: Array = /^function\s+([^\s(]*)(?=\()/.exec(func.toString());
  return name ? name[1] : null;
}
